import { convertDateRangeToDates } from "@wingspanhq/fe-component-library";
import { WorkLogStatus } from "@wingspanhq/payments/dist/interfaces";
import { ApiQueryListWorkLogs } from "../../../../../services/workLog";
import { UrlQuerySort } from "../../../../../shared/hooks/useUrlQuery";
import { getApiDirectionFromTable } from "../../../../../shared/utils/sorting";
import { Filter, SortField, WorkLogPayeeTabFilterStatus } from "./types";

export function createListRequest(
  userId: string,
  filter?: Filter,
  sort?: UrlQuerySort<SortField>,
  isWorkLogReviewWorkflow?: boolean
): ApiQueryListWorkLogs {
  const request: ApiQueryListWorkLogs = {
    "filter[payeeId]": userId,
    "sort[updatedAt]": getApiDirectionFromTable(sort?.direction) || "desc"
  };

  if (filter?.payerId) {
    request["filter[payerId]"] = filter.payerId;
  }

  if (filter?.assignmentId) {
    request["filter[payerPayeeEngagementId][=]"] = filter.assignmentId;
  }

  // TODO: update status method with WorkLogStatus.[status] once backend is done, right now using it as WorkLogStatus
  // for pending enums on the backend

  // Status filtering based on backend WorkLogStatus enum
  if (filter?.status) {
    switch (filter.status) {
      case WorkLogPayeeTabFilterStatus.InProgress:
        if (isWorkLogReviewWorkflow) {
          // In-progress tab shows both Draft and InProgress work logs for payee view
          request["filter[status][in]"] = [
            WorkLogStatus.Draft,
            "InProgress" as WorkLogStatus
          ];
        } else {
          request["filter[status][=]"] = WorkLogStatus.Draft;
        }

        break;
      case WorkLogPayeeTabFilterStatus.Submitted:
        if (isWorkLogReviewWorkflow) {
          // Submitted - awaiting payer approval (maps to backend InReview status)
          request["filter[status][=]"] = "InReview" as WorkLogStatus;
        } else {
          request["filter[status][=]"] = WorkLogStatus.Approved;
        }

        break;
      case WorkLogPayeeTabFilterStatus.Approved:
        request["filter[status][=]"] = WorkLogStatus.Approved;
        break;
      case WorkLogPayeeTabFilterStatus.Rejected:
        request["filter[status][=]"] = "Rejected" as WorkLogStatus;
        break;
    }
  }

  if (filter?.dateRange) {
    const dateRange = convertDateRangeToDates(filter.dateRange);
    if (dateRange) {
      request["filter[startDate][>]"] = dateRange.start;
      request["filter[startDate][<]"] = dateRange.end;
    }
  }

  return request;
}
